import gql from 'graphql-tag'

export const seoFragment = gql`
  fragment SeoFragment on Ether_SeoData {
    description
    title
  }
`
